import {BannerLocation} from 'components/app/AdobeTargetProvider/offer';
import MessageBanner from 'shared/components/MessageBanner';
import {BannerType} from 'shared/components/MessageBanner/Themes';
import {useAdobeTargetGlobalMBox} from 'utils/adobe-target';
import {SafelyParseHTML} from 'utils/parse-html';

interface Props {
  location: BannerLocation;
  noMargin?: boolean;
}

const AEMMessageBanner = ({location, noMargin}: Props) => {
  const adobeTargetValues = useAdobeTargetGlobalMBox();

  const aemMessages = adobeTargetValues.messageBanners;
  if (!aemMessages || aemMessages.length === 0) {
    return null;
  }

  return (
    <>
      {aemMessages
        .filter(
          (messageOffer) =>
            messageOffer.aemMessage.location === location ||
            (!messageOffer.aemMessage.location && location === 'header')
        )
        .map((messageOffer) => {
          const message = messageOffer.aemMessage;

          return (
            <MessageBanner
              key={message.name}
              type={(message.type as BannerType) || 'info'}
              heading={message.heading}
              subtext={<SafelyParseHTML htmlString={message.messageText} />}
              dismissable={message.dismissable ? message.dismissable === 'true' : true}
              contextual={message.location === 'title'}
              {...{noMargin}}
            />
          );
        })}
    </>
  );
};

export default AEMMessageBanner;
